import React from "react";
import Base from "../core/Base";

const OrderProducts = () => {
  return (
    <Base title="Order Products" description="Order Page">
      <h3>This is Order page</h3>
      <h1 className="text-warning">This WebPage is Under Construction...</h1>
    </Base>
  );
};

export default OrderProducts;
